import dayIsNowDayBefore from './dayIsNowDayBefore';
import dayIsSameDay from './dayIsSameDay';
import dayIsNowDayAfter from './dayIsNowDayAfter';
import buildSbmParams from './buildSbmParams';
import findIndexToRemove from './findIndexToRemove';

const removeTimeBlock = (setOfBlocksToRemove, availabilityDay, availabilityOperation, availabilityDaysInCynoTime, SBMId) => {
    let sbmParamsObjectSet = {};
    let sbmParamsTemplate = {
        "start_time":"00:00",
        "end_time":"24:00",
        "is_day_off":0,
        "breaktime":[{"start_time":"", "end_time":""}],
        "index":"",
        "name":"",
        "date":"",
        "unit_group_id":SBMId.toString(),
        "event_id":""
    };

    setOfBlocksToRemove.forEach((blockSet, i) => {
        // 'i' tells us that time zone conversion has moved timeBlocks to a past day/date(0) or a future day/date(2)
        if (blockSet.length > 0) {
            if (dayIsNowDayBefore(i)) {
                const pastDayIndex = (parseInt(availabilityDay, 10) - 1).toString();
                const adjustedPastDaySBMIndex = pastDayIndex === '0' ? '7' : pastDayIndex;
                let dayToModify = availabilityDaysInCynoTime[pastDayIndex];
                let indexToRemove = findIndexToRemove(blockSet, dayToModify);
                dayToModify.splice(indexToRemove, 1);
                
                if (dayToModify.length === 0) {
                    availabilityDaysInCynoTime[pastDayIndex] = [""];
                    let sbmParamsObject = sbmParamsTemplate;
                    sbmParamsObject.is_day_off = 1;
                    sbmParamsObject.index = pastDayIndex.toString();
                    sbmParamsObjectSet[adjustedPastDaySBMIndex] = sbmParamsObject;
                }
                else {
                    availabilityDaysInCynoTime[pastDayIndex] = dayToModify;
                    let sbmParamsObject = buildSbmParams(dayToModify, adjustedPastDaySBMIndex, availabilityOperation, SBMId);
                    sbmParamsObjectSet[adjustedPastDaySBMIndex] = sbmParamsObject;
                };
            }
            else if (dayIsSameDay(i)) {
                const adjustedDaySBMIndex = availabilityDay === '7' ? '0' : availabilityDay;
                let dayToModify = availabilityDaysInCynoTime[adjustedDaySBMIndex];
                let indexToRemove = findIndexToRemove(blockSet, dayToModify);
                dayToModify.splice(indexToRemove, 1);
                
                if (dayToModify.length === 0) {
                    availabilityDaysInCynoTime[adjustedDaySBMIndex] = [""];
                    let sbmParamsObject = sbmParamsTemplate;
                    sbmParamsObject.is_day_off = 1;
                    sbmParamsObject.index = availabilityDay.toString();
                    sbmParamsObjectSet[availabilityDay] = sbmParamsObject;
                }
                else {
                    availabilityDaysInCynoTime[adjustedDaySBMIndex] = dayToModify;
                    let sbmParamsObject = buildSbmParams(dayToModify, availabilityDay, availabilityOperation, SBMId);
                    sbmParamsObjectSet[availabilityDay] = sbmParamsObject;
                };
            }
            else if (dayIsNowDayAfter(i)) {
                let nextDayIndex;
                if (availabilityDay === '6') {
                    nextDayIndex = '0';
                } else if (availabilityDay === '7') {
                    nextDayIndex = '1';
                } else {
                    nextDayIndex = (parseInt(availabilityDay, 10) + 1).toString();
                }
                const adjustedNextDaySBMIndex = (availabilityDay === '7') ? '1' : (parseInt(availabilityDay, 10) + 1).toString();
                let dayToModify = availabilityDaysInCynoTime[nextDayIndex];
                let indexToRemove = findIndexToRemove(blockSet, dayToModify);
                dayToModify.splice(indexToRemove, 1);
                
                if (dayToModify.length === 0) {
                    availabilityDaysInCynoTime[nextDayIndex] = [""];
                    let sbmParamsObject = sbmParamsTemplate;
                    sbmParamsObject.is_day_off = 1;
                    sbmParamsObject.index = adjustedNextDaySBMIndex.toString();
                    sbmParamsObjectSet[adjustedNextDaySBMIndex] = sbmParamsObject;
                }
                else {
                    availabilityDaysInCynoTime[nextDayIndex] = dayToModify;
                    let sbmParamsObject = buildSbmParams(dayToModify, adjustedNextDaySBMIndex, availabilityOperation, SBMId);
                    sbmParamsObjectSet[adjustedNextDaySBMIndex] = sbmParamsObject;
                };
            };
        };
    });
    return [sbmParamsObjectSet, availabilityDaysInCynoTime];
};

export default removeTimeBlock;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/removeTimeBlock.js